import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataStorageSite } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_STORAGE_SITE = defineMasterdataEntity<MasterdataStorageSite>({
  name: 'storage-site',
  responseKey: 'storageSites',
  displayWith: (s) => keyName(s.key, s.name),
  secondaryWith: (s) =>
    s.stock ? [s.stock.key, s.stock.name].filter(Boolean).join(' - ') || null : null,
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-warehouse',
  title: 'Lagerortsuche',
  label: 'Lagerort',
  placeholder: 'Lagerort suchen...',
  columns: [
    {
      label: 'Lagerort',
      type: 'entity',
      icon: 'fa-regular fa-warehouse',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) =>
        e.stock ? [e.stock.key, e.stock.name].filter(Boolean).join(' - ') || null : null,
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'Lager', type: 'text', value: (e) => e.stock?.name ?? null },
  ],
});
